import axios from 'axios';
import { SERVER_API_URL, IS_DEV } from '@src/constants';
import { getDevParamsFromUrl, getUrlParam } from '../utils/global';
import { getUserTrackId } from '../utils/init-analytics';
import dayjs from 'dayjs';
import { BonusGame, GameInitData, PlayResponse } from '../types';
import { GameBackend } from '@src/backend/types';
import { get } from 'svelte/store';
import { gameInitParams } from '../store/misc';
import { chipPrice } from '../store/chips';
import { handlePlayError } from '.';

const token = getUrlParam('secret');

const defaultBackend: GameBackend = {
    init: async token => {
        axios.defaults.baseURL = SERVER_API_URL;

        try {
            const durationStartLoading = dayjs();
            const { data } = await axios.post<GameInitData>('/init', { token, user_track_id: getUserTrackId() });
            console.log('INIT DATA', data);
            const duration = dayjs.duration(dayjs().diff(durationStartLoading)).asSeconds();
            console.log('init request duration ' + duration);
            return data;
        } catch (error) {
            throw error;
        }
    },
    play: async bets => {
        try {
            //В игре не используется, но параметр обязательный, можно отправить минимальный bet_limits
            const $betMinimal = get(gameInitParams).config?.bet_limits[0];
            const bet = $betMinimal;
            const $chipPrice = get(chipPrice);

            const req = {
                bet_type: 'bet',
                bet: bet, //В игре не используется, но параметр обязательный, можно отправить минимальный bet_limits
                // суммы ставок на каждый цвет (в копейках по обычной формуле):
                bets_1: bets[0] * $chipPrice, // BLACK
                bets_2: bets[1] * $chipPrice, // LIGHT_BLUE
                bets_5: bets[2] * $chipPrice, // PURPLE
                bets_10: bets[3] * $chipPrice, // ORANGE
                bets_ball_spin: bets[4] * $chipPrice, // PINK
                bets_plinko: bets[5] * $chipPrice, // BLUE
                bets_cash_reels: bets[6] * $chipPrice, // YELLOW
                bets_fortune_wheel: bets[7] * $chipPrice, // GREEN
                ...(IS_DEV ? getDevParamsFromUrl() : undefined)
            };
            console.log('REQ: ', JSON.stringify(req));
            const { data } = await axios.post<PlayResponse>('/play', { token, req });
            console.log('PLAY: ', data);
            return data;
        } catch (error) {
            console.log('ERROR', error);
            throw error;
        }
    },
    playBonus: async (gameType: BonusGame, choice: number = -1) => {
        try {
            //В игре не используется, но параметр обязательный, можно отправить минимальный bet_limits
            const $betMinimal = get(gameInitParams).config?.bet_limits[0];
            const bet = $betMinimal;
            const req = {
                bet_type: 'bet',
                bet,
                bonus_game: gameType,
                ...(IS_DEV ? getDevParamsFromUrl() : undefined)
            };
            if (choice !== -1) {
                if (choice !== 1 && choice !== 2 && choice !== 3)
                    throw new Error('impossible option in cash reels ' + choice);
                req['cash_reels_select'] = {
                    reel: choice.toString()
                };
            }
            console.log('REQ: ', JSON.stringify(req));
            const { data } = await axios.post<PlayResponse>('/play', { token, req });
            console.log('PLAY: ', data);
            return data;
        } catch (error) {
            console.log('ERROR', error);
            handlePlayError(error);
            throw error;
        }
    }
};

export default defaultBackend;
